<template lang="html">
  <div class="field-container">
    <label>
      <input class="field"
        v-bind="$attrs"
        v-on="inputListeners"
        :value="$attrs.value"
        @focus="focus"
        @blur="focused = false"
        :class="{
          'is-focused': focused,
          'is-empty': isEmpty,
          'has-error': error }"
      />
      <span><span>{{ label }}</span></span>
    </label>
    <div class="error-message">
      <transition>
        <span v-if="error">{{ errorMessage }}</span>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    error: {
      required: false,
      default: false
    },
    errorMessage: {
      required: false,
      default: ""
    }
  },
  data() {
    return {
      focused: false
    }
  },
  computed: {
    isEmpty() {
      return this.$attrs.value ? this.$attrs.value.length === 0 : true
    },
    inputListeners() {
      const vm = this
      return Object.assign({}, this.$listeners, {
        // This ensures that the component works with v-model
        input: function(event) {
          vm.$emit("input", event.target.value)
        }
      })
    }
  },
  methods: {
    focus() {
      this.focused = true
      if (this.onFocus) {
        this.onFocus()
      }
    },
    updateValue(val) {
      val = val.trim()
      this.$emit("input", val)
    }
  }
}
</script>

<style scoped lang="scss">
.field-container {
  text-align: left;
}
/**
 * Form elements
 */
label {
  height: 35px;
  position: relative;
  // color: $font-primary;
  color: white;
  display: block;
  // margin-bottom: 20px;
}

label > span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-weight: 300;
  line-height: 43px;
  // color: $font-primary-light;
  color: rgba(white, 0.8);
  border-bottom: 1px solid $brand-green;
  transition: border-bottom-color 300ms ease-in-out;
  cursor: text;
  pointer-events: none;
}

label > span span {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0% 50%;
  transition: transform 200ms ease-in-out;
  cursor: text;
}

label .field.is-focused + span span,
label .field:not(.is-empty) + span span {
  transform: scale(0.78) translateY(-36px);
  cursor: default;
}

label .field.is-focused + span {
  border-bottom-color: #34d08c;
}
label .field.has-error + span {
  border-bottom-color: $danger;
}

.field {
  @include type-setting(1);
  font-family: inherit;
  background: transparent;
  // font-weight: 300;
  border: 0;
  // color: $font-primary;
  color: rgba(white, 0.8);
  outline: none;
  cursor: text;
  display: block;
  width: 100%;
  padding-bottom: 3px;
  transition: opacity 200ms ease-in-out;
}

.field::-webkit-input-placeholder {
  color: $font-primary;
}
.field::-moz-placeholder {
  color: $font-primary;
}

/* IE doesn't show placeholders when empty+focused */
.field:-ms-input-placeholder {
  color: $font-primary;
}

.field.is-empty:not(.is-focused) {
  opacity: 0;
}

.error-message {
  @include type-setting(-1);
  display: inline-block;
  color: $danger;
  font-weight: bold;
  height: font-size(-1);
}

.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 0.3s ease;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 0.3s ease;
}
.v-enter-to {
  opacity: 1;
}
</style>
